/**
 * Default price per minute in BRL for extra processing time purchases.
 * Exported so consumers can display or use the constant directly.
 */
export const PRICE_PER_MINUTE = 0.27;

/**
 * Computes the total price for purchasing extra processing minutes.
 *
 * @param minutes      - Number of minutes to purchase.
 * @param pricePerMin  - Price per minute in BRL (defaults to PRICE_PER_MINUTE).
 * @returns            Total price in BRL.
 */
export function computeExtraMinutesPrice(
  minutes: number,
  pricePerMin: number = PRICE_PER_MINUTE,
): number {
  return minutes * pricePerMin;
}
